var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _polygon, _g32, _polygon2, _g33, _g34, _g35, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _polygon3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _polygon4, _path21, _polygon5, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g36, _g37, _g38, _polygon6, _polygon7, _path30, _path31, _path32, _g39, _g40, _ellipse, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChimneySweeping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46{fill:none;}.cls-2{stroke-width:.39px;}.cls-2,.cls-12,.cls-47,.cls-13{stroke-miterlimit:10;}.cls-2,.cls-13{stroke:#000;}.cls-3{clip-path:url(#clippath-8);}.cls-4{clip-path:url(#clippath-7);}.cls-5{clip-path:url(#clippath-6);}.cls-6{clip-path:url(#clippath-9);}.cls-7{clip-path:url(#clippath-5);}.cls-8{clip-path:url(#clippath-3);}.cls-9{clip-path:url(#clippath-4);}.cls-10{clip-path:url(#clippath-2);}.cls-11{clip-path:url(#clippath-1);}.cls-12{opacity:.43;stroke:#fff;stroke-linecap:round;stroke-width:4.15px;}.cls-47{stroke:#48b9c1;stroke-width:1.2px;}.cls-47,.cls-48{fill:#fff;}.cls-49{fill:#f7b50a;}.cls-50{fill:#027180;}.cls-51{fill:#052123;}.cls-52{fill:#021719;}.cls-53{fill:#eee;}.cls-54{fill:#e7b5c3;}.cls-55{fill:#ffe2b1;}.cls-56{fill:#fff5ee;}.cls-57{fill:#ffbb4d;}.cls-58{fill:#ffd20a;}.cls-59{fill:#ffd07e;}.cls-60{fill:#f0b220;}.cls-61{fill:#993844;}.cls-62{fill:#979797;}.cls-63{fill:#015a66;}.cls-64{fill:#ba6804;}.cls-65{fill:#d8889f;}.cls-66{fill:#bfbfbf;}.cls-67{fill:#c0e0e4;}.cls-68{fill:#cacaca;}.cls-69{fill:#da89a0;}.cls-70{fill:#16636e;}.cls-71{fill:#41939e;}.cls-72{fill:#160204;}.cls-73{fill:#160d03;}.cls-74{fill:#0b2430;}.cls-75{fill:#1b1c1a;}.cls-76{fill:#2d2d2d;}.cls-77{fill:#84383c;}.cls-13{stroke-width:.34px;}.cls-14{clip-path:url(#clippath-13);}.cls-15{clip-path:url(#clippath-14);}.cls-16{clip-path:url(#clippath-12);}.cls-17{clip-path:url(#clippath-11);}.cls-18{clip-path:url(#clippath-18);}.cls-19{clip-path:url(#clippath-19);}.cls-20{clip-path:url(#clippath-17);}.cls-21{clip-path:url(#clippath-16);}.cls-22{clip-path:url(#clippath-10);}.cls-23{clip-path:url(#clippath-15);}.cls-24{clip-path:url(#clippath-25);}.cls-25{clip-path:url(#clippath-22);}.cls-26{clip-path:url(#clippath-23);}.cls-27{clip-path:url(#clippath-24);}.cls-28{clip-path:url(#clippath-21);}.cls-29{clip-path:url(#clippath-20);}.cls-30{clip-path:url(#clippath-40);}.cls-31{clip-path:url(#clippath-41);}.cls-32{clip-path:url(#clippath-34);}.cls-33{clip-path:url(#clippath-30);}.cls-34{clip-path:url(#clippath-32);}.cls-35{clip-path:url(#clippath-33);}.cls-36{clip-path:url(#clippath-35);}.cls-37{clip-path:url(#clippath-36);}.cls-38{clip-path:url(#clippath-39);}.cls-39{clip-path:url(#clippath-37);}.cls-40{clip-path:url(#clippath-29);}.cls-41{clip-path:url(#clippath-26);}.cls-42{clip-path:url(#clippath-28);}.cls-43{clip-path:url(#clippath-27);}.cls-44{clip-path:url(#clippath-38);}.cls-45{clip-path:url(#clippath-31);}.cls-46{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "91.87 50.02 91.99 50.02 91.99 78.46 58.35 95.28 58.35 66.84 58.48 66.71 91.87 50.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.18 45.69 58.35 66.84 58.35 95.28 16.18 74.13 16.18 45.69"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "75.29 44.58 91.87 50.02 58.48 66.71 75.29 44.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.35 92.19 58.35 97.63 16.18 76.48 16.18 71.04 58.35 92.19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.97,55.71l8.78,4.33v11.01l-8.78-4.33v-11.01Zm-1.61-2.84v15.09l12,5.94v-15.09l-12-5.94Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20.51 51.87 22.37 52.86 22.37 68.07 20.51 69.43 20.51 51.87"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.37 68.07 22.37 68.07 34.36 74.01 34.36 76.36 20.51 69.43 22.37 68.07"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.97 66.84 32.75 71.17 32.75 60.16 23.97 55.71 23.97 66.84"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.6 55.58 24.72 56.08 24.72 66.34 23.6 67.08 23.6 55.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.72 66.34 24.72 66.34 32.75 70.3 32.75 71.66 23.6 67.08 24.72 66.34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "91.99 75.37 91.99 80.94 58.35 97.63 58.35 92.19 91.99 75.37"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "62.93 89.84 72.7 85.02 72.7 63.75 62.93 68.57 62.93 89.84"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "74.68 62.76 74.68 84.89 72.7 84.03 72.7 63.75 74.68 62.76"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.31,70.79l-5.44,2.72v-11.01l5.44-2.72v11.01Zm-7.17-9.65v15.09l8.66-4.33v-15.09l-8.66,4.33Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "88.9 55.96 86.92 56.94 86.92 72.03 88.9 73.39 88.9 55.96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "86.92 72.03 86.92 72.03 78.14 76.36 78.14 78.71 88.9 73.39 86.92 72.03"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "85.31 70.79 79.87 73.52 79.87 62.39 85.31 59.79 85.31 70.79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "85.68 59.54 84.57 60.04 84.57 70.3 85.68 71.04 85.68 59.54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.57 70.3 84.57 70.3 79.87 72.65 79.87 73.89 85.68 71.04 84.57 70.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.17,78.46c0,.62.37.99.99.74.49-.25.99-.99.99-1.61s-.37-.99-.99-.74c-.49.25-.99.99-.99,1.61Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.78,78.71c0,.62.37.99.99.74.49-.25.99-.99.99-1.61s-.37-.99-.99-.74c-.62.25-.99.99-.99,1.61Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m43.27,65.48l8.66,4.33v10.88l-8.66-4.33v-10.88Zm-1.61-2.72v14.96l11.87,5.94v-14.96l-11.87-5.94Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "39.68 61.77 41.66 62.76 41.66 77.6 39.68 78.96 39.68 61.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.66 77.6 41.66 77.6 53.53 83.53 53.53 85.88 39.68 79.08 39.68 78.96 41.66 77.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "43.27 76.36 51.92 80.69 51.92 69.81 43.27 65.48 43.27 76.36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "42.89 65.35 43.88 65.85 43.88 75.99 42.89 76.73 42.89 65.35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "43.88 75.99 43.88 75.99 51.92 79.95 51.92 81.18 42.89 76.73 43.88 75.99"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "62.93 88.73 72.7 84.15 74.68 84.89 62.93 90.7 62.93 88.73"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.34 97.38 83.09 91.45 80.12 89.96 68.49 95.9 71.34 97.38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.49 95.9 80.12 89.96 80.12 87.74 68.49 93.67 68.49 95.9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.34 99.86 83.09 93.92 83.09 91.45 71.34 97.38 71.34 99.86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "74.68 84.89 80.12 87.74 68.49 93.67 62.93 90.7 74.68 84.89"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "62.93 95.4 71.34 99.86 71.34 97.38 68.49 95.9 68.49 93.67 62.93 90.7 62.93 95.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "97.06 52 78.02 45.94 32.88 23.56 54.52 30.98 97.06 52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "12.84 49.4 55.26 70.55 78.02 45.94 32.88 23.56 12.84 49.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "55.26 71.91 55.26 70.55 12.84 49.4 12.84 50.39 55.26 71.91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "55.26 71.91 55.26 70.55 78.02 45.94 97.06 52 97.06 52.86 78.39 46.93 55.26 71.91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "45.36 36.02 39.61 33.15 39.61 41.77 45.36 44.64 45.36 36.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "31.76 50.19 39.61 41.77 39.61 33.15 31.76 37.17 31.76 50.19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.61,33.15l-7.85,4.02,5.74,2.87,7.85-4.02-5.74-2.87m0,1.15l3.64,1.72-5.74,2.87-3.64-1.72,5.74-2.87"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "37.51 53.06 31.76 50.19 31.76 37.17 37.51 40.04 37.51 53.06"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "37.51 53.06 45.36 44.64 45.36 36.02 37.51 40.04 37.51 53.06"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m54.79,99.8l34.91-18.13c1.08-.64,1.08-2.2,0-2.83l-42.1-22.19c-.52-.3-1.15-.3-1.67,0l-32.68,19.54c-1.06.63-1.08,2.17-.02,2.81l39.87,20.78c.52.32,1.17.32,1.69.02Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 52.17,
    y: 43.84,
    width: 46,
    height: 57.63
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 10,
    y: 39.51,
    width: 54.54,
    height: 61.96
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 52.29,
    y: 38.4,
    width: 45.76,
    height: 34.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 10,
    y: 64.86,
    width: 54.54,
    height: 38.95
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 16.18,
    y: 46.68,
    width: 24.36,
    height: 33.39
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 14.33,
    y: 45.69,
    width: 14.22,
    height: 29.93
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 14.33,
    y: 61.89,
    width: 26.22,
    height: 20.65
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 17.79,
    y: 49.52,
    width: 21.15,
    height: 27.82
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 17.42,
    y: 49.4,
    width: 13.48,
    height: 23.87
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 17.42,
    y: 60.16,
    width: 21.52,
    height: 17.68
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 52.17,
    y: 69.19,
    width: 46,
    height: 34.63
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 56.75,
    y: 57.56,
    width: 22.14,
    height: 38.46
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 66.51,
    y: 56.57,
    width: 14.34,
    height: 34.5
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 71.96,
    y: 50.64,
    width: 21.02,
    height: 31.78
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 80.74,
    y: 49.77,
    width: 14.34,
    height: 29.8
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 71.96,
    y: 65.85,
    width: 23.13,
    height: 19.04
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 73.69,
    y: 53.61,
    width: 17.81,
    height: 26.09
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 78.39,
    y: 53.36,
    width: 13.48,
    height: 23.87
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 73.69,
    y: 64.12,
    width: 18.18,
    height: 15.95
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 57.98,
    y: 70.59,
    width: 14.34,
    height: 14.87
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 58.6,
    y: 70.84,
    width: 14.34,
    height: 14.87
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 35.48,
    y: 56.57,
    width: 24.24,
    height: 33.27
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 33.5,
    y: 55.58,
    width: 14.34,
    height: 29.56
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 33.5,
    y: 71.41,
    width: 26.22,
    height: 20.65
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 37.08,
    y: 59.29,
    width: 21.02,
    height: 27.58
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 36.71,
    y: 59.17,
    width: 13.36,
    height: 23.74
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 36.71,
    y: 69.81,
    width: 21.39,
    height: 17.56
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 56.75,
    y: 77.97,
    width: 24.11,
    height: 18.92
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 62.31,
    y: 83.78,
    width: 26.96,
    height: 19.79
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 62.31,
    y: 81.55,
    width: 23.99,
    height: 20.53
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 65.15,
    y: 85.26,
    width: 24.11,
    height: 20.78
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 56.75,
    y: 78.71,
    width: 29.56,
    height: 21.15
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 56.75,
    y: 84.52,
    width: 20.78,
    height: 21.52
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "97.06 52 78.02 45.94 32.88 23.56 54.52 30.98 97.06 52"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 26.7,
    y: 17.37,
    width: 76.55,
    height: 40.81
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "12.84 49.4 55.26 70.55 78.02 45.94 32.88 23.56 12.84 49.4"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 6.66,
    y: 17.37,
    width: 77.54,
    height: 59.36
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 6.66,
    y: 43.22,
    width: 54.78,
    height: 34.87
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 49.08,
    y: 39.76,
    width: 54.16,
    height: 38.34
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 36.74,
    cy: 33.53,
    r: 28.22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m66.91,43.8c-2.47,6.55-7.99,17.67-17.56,20.54-13.81,4.16-28.23,1.77-34.96-12.17l19.49-25.15,33.03,16.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m68.53,38.89s-.51,2.01-1.6,4.91h-.02l-33.03-16.79,34.65,11.87Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m70.19,32.35c-.02-.8-.08-1.58-.16-2.35-.03-.3-.06-.59-.13-.88-1.22-9.3-6.24-17.4-13.48-22.67-1.76-1.28-3.65-2.39-5.63-3.31C46.52,1.13,41.75.03,36.74.03,18.23.03,3.25,15.04,3.25,33.53c0,8.16,2.91,15.64,7.78,21.45.37.45.75.88,1.15,1.31,1.94,2.08,4.13,3.92,6.55,5.46,1.89,1.22,3.92,2.24,6.05,3.06,3.71,1.42,7.75,2.21,11.96,2.21,4.53,0,8.87-.91,12.82-2.56.37-.16.74-.3,1.12-.48,3.25-1.5,6.23-3.49,8.82-5.91.86-.78,1.66-1.62,2.43-2.51.02-.02.03-.03.03-.05,2.67-3.04,4.77-6.56,6.2-10.42.1-.24.18-.5.26-.74.05-.13.1-.27.13-.4.45-1.3.8-2.66,1.04-4.02.03-.14.06-.29.08-.45.37-1.92.54-3.92.54-5.95,0-.4-.02-.8-.02-1.18Zm-6.23,9.81c-.53,1.66-1.2,3.27-2,4.77,0,.03-.02.05-.03.05-2.43,4.58-6.1,8.42-10.55,11.09-.24.13-.48.27-.7.4-.37.21-.75.4-1.12.59-3.86,1.95-8.21,3.04-12.82,3.04-4.27,0-8.32-.94-11.96-2.63-2.18-.99-4.21-2.26-6.05-3.76-1.26-1.02-2.43-2.14-3.49-3.36-.38-.45-.77-.9-1.1-1.36-3.75-4.82-5.97-10.89-5.97-17.46,0-15.78,12.79-28.59,28.57-28.59,2.99,0,5.89.46,8.61,1.33,2.24.7,4.37,1.7,6.34,2.9,6.98,4.31,11.97,11.51,13.27,19.95.05.3.1.61.11.91.16,1.15.22,2.32.22,3.51,0,1.3-.08,2.56-.27,3.79-.02.22-.06.43-.1.66-.18,1.3-.46,2.55-.83,3.76-.05.14-.08.27-.13.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m21.07,14.12s-18.98,13.91-3.76,34.02"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m31.03,45.97c-2.28,0-4.14,1.01-4.14,2.26s1.85,2.26,4.14,2.26,4.14-1.01,4.14-2.26-1.85-2.26-4.14-2.26Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m27.79,46.81s-.3,2.87.77,3.03c1.07.16.85-1.74.85-1.74l-.16-1.49-1.46.2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m33.22,44.53l1.46,1.32s.2.75-.49.76-1.53-.53-1.53-.53l-1-.5.21-1.05h1.35Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m27.79,46.81c.17.14.43.21.7.24.45.05.91,0,.91,0l.86-7.96.81-6.16.5.42.11.1.22,4.48-.24,6.98c.16.15.54.14.89.09.38-.06.73-.17.73-.17l.66-6.9c.26-2-.62-8.19-.62-8.19l-5.36.73-.17,16.35Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m32.54,23.76l.03,1.23.44.47.49.52,1.4,1.59.18.19h.01s.1,0,.1,0l.19-.02.21-.13h.05s-.02-.05-.02-.05c-.77-1.33-1.14-2.87-1.72-3.64l.09-.94-.64.33-.06.03-.76.39Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m34,23.01c-.25.52-.75.73-1.46.75l-.08-2.97.77-1.11c.73.17,1.12.97.89,2.26l-.12,1.06Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m33.63,23.5l-.03-1.55-.37-2.27c-.67-.41-1.48-.54-2.44-.57-1.51.42-2.71,1.17-3.64,2.11l.37,2.01.16,1.26c.31,1.42.24,4.07.18,5.73.89,1.43,2.9.22,4.89-.02.35-.11.67-.1.98-.09-.79-1.85-.15-4.76-.1-6.61Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m30.96,29.55c-.81-.38-1.41-.84-1.78-1.44-.72-1.07-.99-2.67-1.12-4.31l-.64.56.22,1.27c.31,1.42.34,2.97.27,4.62.89,1.43,2.9.22,4.89-.02l.42-.16-2.25-.52Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "33.44 25.91 34.91 27.58 35.09 27.77 35.08 27.78 35.14 27.89 35.19 28 35.28 27.9 35.21 27.78 35.18 27.73 34.78 27.1 33.57 24.45 33.44 25.91"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m27.87,20.62s1.26-1.24,1.67-.59l2.34,4.43s.18-3.63,0-4.77c0,0,.51-.4.95-.01,0,0,1.43-.16.82,3.83,0,0-.33,3.37-.27,4.99,0,0,.59,1.56.08,1.75l-.33.21s-.79-1.37-.79-1.95c0,0,.09,2.32-.33,2.44,0,0-3.43-.42-4.12-.72,0,0,.12-3.04-.07-3.61l-.28-1.39.72-2.22s.58-1.5-.37-2.39Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m29.17,19.86s1.55,1.41,1.42,5.15c0,0,1.7,0,1.96-.27,0,0,.27-3.84-.29-5.07,0,0,.07-.6.62.08,0,0,.41,3.84.22,4.95l.4-.1v.83s-2.98.87-5.87.26l-.1-.33.14-.51,2.12.2s-.14-3.29-.5-3.78c0,0-.24-.71-1-1.07,0,0,.27-.43.88-.34Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m27.87,27.23s4.81.23,5.52-.53l-.04.84s-1.27.65-5.42.45l-.07-.77Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m25.29,26.25c.02,1.37,1.97,2.08,3.81,2.77.23.09.46.17.69.26l.02-.02.21-.27c.17-.24.37-.53.29-.55-.05,0-.19-.09-.39-.22-.9-.58-2.98-2.08-2.98-2.16.19-.28.32-.57.52-.84l-1.2-.54-.47-.21c-.19.53-.41,1.11-.5,1.79Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m27.52,25.22c-.73-.17-1.39-.39-1.74-.79.08-.37.23-.72.36-1.01.03-.96.59-1.72,1.26-2.4.72.23.87,1.23.59,2.71-.19.53-.36,1.01-.48,1.49Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m29.82,20.3c-.08-.21-.16-.42.03-.7.21-.34.45-.54.46-.6.61-.69.51-1.36.84-1.41.26,0,.54.7.67,1.25.12.6,0,1.35-.13,1.96-.17.73-1.6.53-1.87-.5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m29.71,20.41c-.07-.18-.03-.34.03-.6.09-.37.15-1.13.16-1.18.58-.59.74-.55,1.01-.54.22,0,.47.61.58,1.08.1.52,0,1.17-.12,1.7-.15.63-1.38.46-1.67-.44Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m33.21,18.01c-.24,1.09-.47,2.72-1.12,2.58-.46.02-.97-.16-1.39-.6-.91-.75-1.14-1.76-1.08-2.94.18-1.1.82-1.56,1.86-1.46,1.14.44,1.79,1.17,1.73,2.41Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m30.7,15.52c-1.24.53-1.62,1.68-.99,3.32l.1.27.44-.42.43.31.23-.96c1.02.37,2.04,0,2.35-.49.41-.81-1-2.47-2.56-2.04Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "30.2 19.09 30.34 19.04 30.42 18.92 30.45 18.66 30.41 18.39 30.23 18.17 29.89 18.27 29.85 18.66 30.08 19.01 30.2 19.09"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m32.42,18.45l-.1-.07-.34.1-.25.03h-.07l-.1.11.02.08.05-.07.13-.03h.02l.13-.03.15-.02h.03l.21-.05.13.02v-.07l-.02-.02Zm-.67.1l-.07-.03h-.02l-.1.11.07.02.13-.03h.02l.13-.03-.16-.03Zm.67-.1l-.33.11.21-.05.13.02v-.07l-.02-.02Zm.84-.38l-.07.02c-.1.03-.25.15-.41.21l-.02.02-.11.1-.21.11c-.02.23-.05.38-.18.44l-.33.1-.08-.03-.25-.13-.02-.18-.03.03c-.08.23.1.38.31.41.26.02.59-.15.64-.57l.13-.11c-.02.26.07.36.16.34l-.1-.34.15-.11.21-.11.11-.05.1-.05.05.07.02-.07-.08-.08Zm-.84.38l-.33.11.21-.05.13.02v-.07l-.02-.02Zm-.66.16h.02l.13-.03-.16-.03-.07-.03h-.02l-.1.11.07.02.13-.03Zm1.05.2l.26-.15-.26.15Zm-.39-.36l-.33.11.21-.05.13.02v-.07l-.02-.02Zm-.67.1l.02.07h.02l.13-.03-.16-.03Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "31.63 18.64 31.55 18.77 30.52 18.53 30.54 18.4 31.63 18.64"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m30.68,18.94l.03.33c.05.2.16.35.28.49.18.15.43.31.71.14.44-.42.99-.69,1.23-.47,0,.72.12,1.39-.61,1.45-.59,0-1.28-.39-1.69-.83l-.16-.35c-.1-.34-.13-.67-.03-.99l.24.22Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m32.77,19.75c-.01.13-.18.44-.37.42s-.26-.03-.31-.16c-.11-.21.3-.36.44-.42l.25.16Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m32.56,19.86c.05.2.1.34.23.35l-.55.27c.15-.18.17-.38.18-.51l.14-.12Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m31.68,33.48l.22,4.44h0s-.24,6.93-.24,6.93l.04.08c.16.11.46.11.76.07l.08-.11-.11-.87-.03-.05-.24-.26.03-.15.49-.24.04-.14-.26-.39-.02-.06.04-3.87v-.03s.18-.55.18-.55v-.07s-.21-.41-.21-.41v-.08s.1-.31.1-.31v-.04c0-.26-.19-3.43-.3-4.01-.09-.47-.74-.86-1.03-1.01l-.14.09v.44l.03.07.55.47.03.07Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m33.44,17.12s-.23,1.23-3.4.89h0c-.59-.3-.76-.67-.76-.67.11-2.38,1.22-2.73,2.54-2.53,1.27.2,1.62,2.31,1.62,2.31Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m33.76,17.6c-.31.57-1.36.86-1.7.96-.34.1-.61-.19-.61-.19-.63-.05-1.08-.2-1.41-.37,3.16.34,3.4-.89,3.4-.89.48.31.33.48.33.48Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m29.88,15.32s.85.09,1.15,1.02l-1.15-1.02Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m30.72,14.83s1.17.34,1.31,1.34h.4s-.27-1.17-1.13-1.38h-.15s-.42.04-.42.04Z"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 30.04,
    y: 23.58,
    width: 24.89,
    height: 30.63
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 22.19,
    y: 23.58,
    width: 27,
    height: 36.19
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 22.19,
    y: 23.58,
    width: 32.74,
    height: 26.04
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.36 29.2 35.28 29.36 35.28 29.45 23.52 32.79 23.22 32.63 23.39 32.32 35.28 28.95 35.36 29.2"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.37 26.1 44.89 26.73 37.1 28.95 36.92 28.99 36.65 29.08 36.54 29.11 36.26 29.17 36.06 29.24 35.8 29.31 35.11 29.5 35.18 29.37 35.23 29.04 35.28 28.95 35.59 28.86 36.72 28.54 45.37 26.1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m29.1,29.02h0s.64.28.64.28c.08.21.22.44.37.6.28.19.45.3.72.49l.42.67h0s.02.03.02.03l.2.05h0s0-.14,0-.14l-.3-.65.17.11.65.79c.15.17.3.07.23-.14l-.42-.67.72.66c.17.1.18-.17.02-.33l-.33-.43-.36-.4.14-.03.43.1c.17.11.26,0,.17-.15l-.37-.34h0s-.09-.15-.09-.15l-.43-.36-.68-.41-.67-.15-.41-.2-.11-.05c-.37-.09-.46.08-.58.45l-.08.25-.05.15Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m36.95,29.04l.1.13-.15.15-.25-.25-.26-.28.15.31.18.39c.1.15-.1.25-.18.1l-.28-.43-.2-.28h-.1l.1.34.1.36c.05.15-.1.18-.2.05l-.16-.34-.21-.44v-.02l-.18-.13-.13.23-.26.08-.02-.13-.02-.05.25-.79-.03-.07-.05-.1-.07-.11h.02l.08-.05.1-.05.28-.15.08.05.33.2h.02c.18.15.36.33.51.51l.23.25.38.41-.15.1Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m25.29,26.25c.02,1.37,1.97,2.08,3.81,2.77h0s.64.28.64.28c.08.21.22.44.37.6.28.19.45.3.72.49l.42.67.16.11-.64-1.16c-.1-.18-.25-.33-.43-.44-.14-.08-.3-.31-.51-.44-.2-.12-.44-.12-.68-.27-1.14-.69-2.59-1.6-3.04-2.01-.59-.54-.16-1.58.09-2.08l-.32-.21-.09-.11c-.19.53-.41,1.11-.5,1.79Z"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 22.19,
    y: 27.6,
    width: 24.89,
    height: 35.04
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 27.93,
    y: 26.45,
    width: 27,
    height: 36.19
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.24,
    cy: 26.39,
    rx: 1.6,
    ry: 3.14,
    transform: "translate(-2.66 5.2) rotate(-6.39)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.13,
    y1: 24.93,
    x2: 47.9,
    y2: 24.15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.3,
    y1: 25.34,
    x2: 48.08,
    y2: 24.56
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.35,
    y1: 26.68,
    x2: 48.12,
    y2: 25.91
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.36,
    y1: 25.88,
    x2: 48.14,
    y2: 25.11
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.42,
    y1: 26.43,
    x2: 48.19,
    y2: 25.65
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.83,
    y1: 24.67,
    x2: 47.61,
    y2: 23.9
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.96,
    y1: 25.77,
    x2: 47.74,
    y2: 25
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.06,
    y1: 24.54,
    x2: 47.58,
    y2: 23.33
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.66,
    y1: 24.78,
    x2: 46.34,
    y2: 22.96
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.85,
    y1: 24.54,
    x2: 46,
    y2: 22.61
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.93,
    y1: 24.58,
    x2: 46.62,
    y2: 22.77
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.94,
    y1: 24.42,
    x2: 45.55,
    y2: 22.52
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.89,
    y1: 25.53,
    x2: 47.41,
    y2: 24.33
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.57,
    y1: 24.4,
    x2: 47.09,
    y2: 23.2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.78,
    y1: 24.46,
    x2: 47.3,
    y2: 23.26
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.47,
    y1: 26.97,
    x2: 48.25,
    y2: 26.19
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.39,
    y1: 27.26,
    x2: 48.17,
    y2: 26.49
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.53,
    y1: 27.51,
    x2: 48.31,
    y2: 26.74
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.25,
    y1: 27.84,
    x2: 48.19,
    y2: 27.87
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.76,
    y1: 28.12,
    x2: 47.43,
    y2: 29.12
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.58,
    y1: 27.97,
    x2: 46.99,
    y2: 29.3
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.77,
    y1: 28.05,
    x2: 46.88,
    y2: 29.64
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.79,
    y1: 27.87,
    x2: 46.54,
    y2: 29.66
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.11,
    y1: 28.05,
    x2: 47.78,
    y2: 29.04
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46,
    y1: 28.45,
    x2: 47.67,
    y2: 29.44
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.89,
    y1: 24.59,
    x2: 47.83,
    y2: 24.62
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.99,
    y1: 25.64,
    x2: 47.93,
    y2: 25.67
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.34,
    y1: 27.51,
    x2: 48.28,
    y2: 27.54
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.17,
    y1: 28.11,
    x2: 48.11,
    y2: 28.13
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.11,
    y1: 28.33,
    x2: 48.04,
    y2: 28.42
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.99,
    y1: 25.85,
    x2: 47.92,
    y2: 25.95
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.94,
    y1: 27.83,
    x2: 43.3,
    y2: 28.87
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.7,
    y1: 27.45,
    x2: 43.06,
    y2: 28.49
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.45,
    y1: 26.13,
    x2: 42.81,
    y2: 27.18
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.56,
    y1: 26.92,
    x2: 42.92,
    y2: 27.97
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.42,
    y1: 26.39,
    x2: 42.78,
    y2: 27.44
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.27,
    y1: 28.03,
    x2: 43.63,
    y2: 29.08
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.97,
    y1: 26.97,
    x2: 43.33,
    y2: 28.01
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.06,
    y1: 28.21,
    x2: 43.75,
    y2: 29.63
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.42,
    y1: 27.9,
    x2: 45.03,
    y2: 29.8
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.27,
    y1: 28.17,
    x2: 45.43,
    y2: 30.1
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.18,
    y1: 28.14,
    x2: 44.79,
    y2: 30.04
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.2,
    y1: 28.3,
    x2: 45.88,
    y2: 30.11
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.07,
    y1: 27.2,
    x2: 43.76,
    y2: 28.62
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.57,
    y1: 28.26,
    x2: 44.25,
    y2: 29.69
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.36,
    y1: 28.24,
    x2: 44.04,
    y2: 29.66
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.28,
    y1: 25.87,
    x2: 42.64,
    y2: 26.91
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.31,
    y1: 25.56,
    x2: 42.67,
    y2: 26.61
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.14,
    y1: 25.34,
    x2: 42.5,
    y2: 26.38
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.36,
    y1: 24.97,
    x2: 42.44,
    y2: 25.25
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.8,
    y1: 24.62,
    x2: 43,
    y2: 23.9
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45,
    y1: 24.74,
    x2: 43.4,
    y2: 23.64
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.8,
    y1: 24.69,
    x2: 43.45,
    y2: 23.29
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.81,
    y1: 24.87,
    x2: 43.78,
    y2: 23.22
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.46,
    y1: 24.74,
    x2: 42.66,
    y2: 24.02
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.51,
    y1: 24.33,
    x2: 42.71,
    y2: 23.61
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.22,
    y1: 28.12,
    x2: 43.3,
    y2: 28.4
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.96,
    y1: 27.1,
    x2: 43.04,
    y2: 27.38
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.32,
    y1: 25.31,
    x2: 42.4,
    y2: 25.59
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.39,
    y1: 24.7,
    x2: 42.47,
    y2: 24.97
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.43,
    y1: 24.47,
    x2: 42.5,
    y2: 24.68
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.93,
    y1: 26.89,
    x2: 43,
    y2: 27.1
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.1,
    y1: 24.28,
    x2: 43.21,
    y2: 22.56
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.5,
    y1: 24.08,
    x2: 43.61,
    y2: 22.35
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.84,
    y1: 23.95,
    x2: 44.95,
    y2: 22.22
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.04,
    y1: 23.99,
    x2: 44.15,
    y2: 22.26
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.58,
    y1: 23.89,
    x2: 44.69,
    y2: 22.17
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.96,
    y1: 24.39,
    x2: 44.07,
    y2: 22.66
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.72,
    y1: 24.47,
    x2: 43.42,
    y2: 23.03
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.12,
    y1: 23.8,
    x2: 45.23,
    y2: 22.08
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.42,
    y1: 23.86,
    x2: 45.53,
    y2: 22.14
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 43.78,
    y1: 24.54,
    x2: 43.68,
    y2: 22.6
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.83,
    y1: 24.37,
    x2: 44.72,
    y2: 22.43
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.04,
    y1: 24.36,
    x2: 45,
    y2: 22.42
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 46.58,
    y1: 28.38,
    x2: 47.08,
    y2: 29.99
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 46.2,
    y1: 28.5,
    x2: 46.7,
    y2: 30.1
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 45.04,
    y1: 28.41,
    x2: 45.54,
    y2: 30.01
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 45.73,
    y1: 28.49,
    x2: 46.23,
    y2: 30.1
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 45.26,
    y1: 28.49,
    x2: 45.76,
    y2: 30.1
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 45.86,
    y1: 28.16,
    x2: 46.36,
    y2: 29.77
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 46.08,
    y1: 28.12,
    x2: 46.97,
    y2: 29.55
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 44.78,
    y1: 28.49,
    x2: 45.28,
    y2: 30.1
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 44.54,
    y1: 28.39,
    x2: 45.03,
    y2: 30
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 46.88,
    y1: 28.21,
    x2: 46.68,
    y2: 29.88
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 45.97,
    y1: 28.2,
    x2: 45.77,
    y2: 29.87
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 45.79,
    y1: 28.18,
    x2: 45.52,
    y2: 29.84
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChimneySweeping);
export default __webpack_public_path__ + "static/media/chimney-sweeping.c7edb0c12080bbae1eddbf054825a040.svg";
export { ForwardRef as ReactComponent };